import {MessageItemLink, MessageItemLinkProps} from './MessageItemLink'
import {toAbsoluteUrl} from '../../../../../_gori/helpers'

type MessageItemLinkBoxProps = MessageItemLinkProps

export const MessageItemLinkBox = ({...linkProps}: MessageItemLinkBoxProps) => {
  return (
    <div className='bg-light border border-1 border-primary rounded-2 align-self-start'>
      <div className='border-bottom border-1 border-primary d-flex justify-content-center align-items-center py-4'>
        <img
          className='w-45px h-25px'
          src={toAbsoluteUrl('/media/gori/chatbot/logo.svg')}
          alt='logo'
        />
      </div>
      <div className='p-2'>
        <MessageItemLink {...linkProps} />
      </div>
    </div>
  )
}
